.container {
    padding: 16px;
    max-width: 500px;
}
